import * as React from "react";
import { Activity, ArrowRight, Bone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
const agents = [{
  title: "Spine Surgery Agent",
  description: "Precision-driven AI assistance designed for complex spinal procedures, offering advanced guidance and meticulous surgical planning.",
  icon: Bone,
  link: "#"
}, {
  title: "Pain Management Agent",
  description: "Comprehensive restorative care models utilizing predictive analytics to optimize patient vitality and long-term recovery.",
  icon: Activity,
  link: "#"
}];
export default function AgentOptions() {
  return <section id="agent-options" className="bg-background py-24 px-6 md:px-12">
      <div className="mx-auto max-w-6xl">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
          {agents.map((agent, i) => <Card key={i} data-index={i} className="bg-card border-none rounded-lg shadow-sm transition-all duration-300 hover:shadow-md hover:-translate-y-1 flex flex-col h-full">
              <CardHeader className="text-center pt-12 pb-6">
                <div className="mx-auto bg-primary/5 p-5 rounded-full mb-6 flex items-center justify-center">
                  <agent.icon className="w-10 h-10 text-primary" strokeWidth={1.5} />
                </div>
                <CardTitle className="font-default text-2xl md:text-3xl font-semibold text-foreground tracking-tight">
                  {agent.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="text-center flex-grow px-8 md:px-12">
                <p className="font-default text-muted-foreground text-base md:text-lg leading-relaxed">
                  {agent.description}
                </p>
              </CardContent>
              <CardFooter className="flex justify-center pb-12 pt-6">
                <Button asChild className="rounded-full bg-primary text-primary-foreground font-default font-semibold hover:bg-primary hover:brightness-110 transition-all duration-200 px-8 py-6 h-auto text-base shadow-none">
                  <Link to={agent.link}>
                    Discover Capabilities <ArrowRight className="ml-2 w-5 h-5" />
                  </Link>
                </Button>
              </CardFooter>
            </Card>)}
        </div>
      </div>
    </section>;
}